var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCampaignMetrics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.45251,
    y: 1.98596,
    width: 8.74083,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(45 8.45251 1.98596)",
    fill: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.9853,
    y: 1.06067,
    width: 11.6958,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(135 21.9853 1.06067)",
    fill: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.90097,
    y: 3.11475,
    width: 11.0879,
    height: 0.75,
    rx: 0.375,
    transform: "rotate(135 8.90097 3.11475)",
    stroke: "#3E3D3D",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 17.0002,
    width: 5,
    height: 6.5,
    rx: 0.5,
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 11.0002,
    width: 5,
    height: 12.5,
    rx: 0.5,
    stroke: "#3E3D3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 6.50024,
    width: 5,
    height: 17,
    rx: 0.5,
    stroke: "#3E3D3D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignMetrics);
export default __webpack_public_path__ + "static/media/campaignMetrics.a79e6aded3b681278c300aefecf71088.svg";
export { ForwardRef as ReactComponent };